import s from './BetaTag.module.css'

export const BetaTag = () => <span className={s.tag}>Beta</span>
